// extracted by mini-css-extract-plugin
export default {"negative":"WrZT3"};